export const DEFAULTS = {
	colors: ['#92A1C6', '#146A7C', '#F0AB3D', '#C271B4', '#C20D90'],
	name: 'Clara Barton',
	square: false,
	size: 40
};
